import(/* webpackMode: "eager" */ "/Users/ankitvirani/download_staging/6a5570cb2cc250001417797a_1784553406015_531c8891/syhj/src/app/client-portal/page.tsx");
